module.exports = __webpack_public_path__ + "static/numbers-1-city-473abb04132741d95f348a4ef73e27bf.png";